"use client";

import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: "How do I get started?",
    answer: "We review every application by hand. Once approved, you get an invite code by email. Use it to create your account and set up your first workspace in minutes.",
  },
  {
    question: "Will this get my LinkedIn account flagged?",
    answer: "No. Pipeout uses human-like timing, respects rate limits, and pauses campaigns when someone replies. You can adjust timing per campaign.",
  },
  {
    question: "Which AI models can I use?",
    answer: "OpenAI GPT, Anthropic Claude, and Google Gemini. Bring your own API keys and pick your model per workspace.",
  },
  {
    question: "How much does it cost?",
    answer: "Pipeout is free during the private beta. We're still finalizing pricing and will share details before launch.",
  },
  {
    question: "Can I use my own API keys?",
    answer: "Yes. Your keys are encrypted and stored separately per workspace. We never see them in plain text.",
  },
  {
    question: "Is my data kept private?",
    answer: "Every workspace is completely isolated. Leads, campaigns, settings, and API keys are separated at the database level.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section-dark py-24 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title text-2xl md:text-3xl lg:text-4xl font-extrabold text-white mb-6">
            Common Questions
          </h2>
          <p className="section-subtitle text-lg text-text-secondary max-w-2xl mx-auto">
            Quick answers before you get started.
          </p>
        </div>

        <div className="card-clean-dark rounded-3xl border border-white/6 overflow-hidden">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            const isLast = index === faqs.length - 1;

            return (
              <div key={faq.question} className={!isLast ? "border-b border-white/5" : ""}>
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  className={`w-full py-5 px-6 flex items-center justify-between text-left cursor-pointer group transition-colors duration-180 ${
                    isOpen ? 'bg-white/[0.05]' : 'hover:bg-white/[0.03]'
                  }`}
                >
                  <span className="text-sm sm:text-base font-semibold text-white pr-4 group-hover:text-accent-blue transition-colors duration-180">
                    {faq.question}
                  </span>
                  <ChevronDown
                    className={`h-5 w-5 text-text-secondary flex-shrink-0 transition-transform duration-180 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-180 ease-in-out ${
                    isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pt-2 pb-6 text-sm text-text-secondary leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
